import { createContext } from "@ecopages/radiant/context";
export const fieldContext = createContext(/* @__PURE__ */Symbol.for("rui-field-context"));